import { ROUTES } from '../../utils/constants';

export interface SidebarNavLocation {
  pathname: string;
  search: string;
}

export interface SidebarNavItemLike {
  route: string;
  activeRoutes?: string[];
  /** Match pathname exactly (no child-prefix match). Used to avoid double-highlight on nested routes. */
  exactActiveRoutes?: string[];
  teacherAssignmentsCommTasks?: boolean;
  teacherAssignmentsDefault?: boolean;
}

/**
 * Whether a sidebar item should show the active state for the current location.
 */
export function isNavItemActive(location: SidebarNavLocation, item: SidebarNavItemLike): boolean {
  if (item.exactActiveRoutes?.length) {
    return item.exactActiveRoutes.includes(location.pathname);
  }

  if (item.teacherAssignmentsCommTasks) {
    if (location.pathname !== ROUTES.TEACHER_ASSIGNMENTS) return false;
    return new URLSearchParams(location.search).get('open') === 'communication';
  }

  if (item.teacherAssignmentsDefault) {
    if (location.pathname !== ROUTES.TEACHER_ASSIGNMENTS) return false;
    return new URLSearchParams(location.search).get('open') !== 'communication';
  }

  if (item.activeRoutes?.length) {
    return item.activeRoutes.some(
      (r) => location.pathname === r || location.pathname.startsWith(`${r}/`)
    );
  }

  return location.pathname === item.route || location.pathname.startsWith(`${item.route}/`);
}
